import React from 'react';
import {
  Input, InputNumber,
} from 'antd';
import {
  Box, Text,
} from '../../shared/components';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import NumberFormat from '../../shared/components/dataDisplay/NumberFormat';

export default function ArticulosDevolverList({
  articulosSeleccionados, nombrePack, onChangeUndsArticulo,
}) {
  let content = '';
  const articulosArray = (typeof (articulosSeleccionados) !== 'undefined') ? articulosSeleccionados : [];
  const precioTotal = articulosArray.reduce((totalPrecio, articulo) => totalPrecio + parseFloat(articulo.lineaPvp), 0);


  content = (
    <Box>
      <TwoColumnsFlexLayout
        leftContent={(
          <Box>
            <Text fontSize="16"><b>Artículos</b></Text>
          </Box>
        )}
        rightContent={(
          <Box>
            <NumberFormat fontWeight="semibold" number={precioTotal} />
          </Box>
        )}
        rightColumnStyle={{ textAlign: 'right' }}
      />

      <TwoColumnsFlexLayout
        leftContent={(
          <Box mt="16">
            <Text fontSize="16">{nombrePack}</Text>
          </Box>
        )}
      />

      <Box id="articulos_list_devolucion">
      {articulosArray.map(item => (
        <Box key={item.lineaDetalle}>
          <TwoColumnsFlexLayout
            leftContent={(
              <TwoColumnsFlexLayout
                leftContent={(
                  <Box mt="12">
                    <InputNumber onChange={value => onChangeUndsArticulo(value, item.lineaDetalle)} defaultValue={item.lineaUds} min={1} max={item.lineaUds} style={{ width: '46px', height: '24px', paddingBottom:'6px' }} />
                  </Box>
                )}
                rightContent={(
                  <Box mt="16" ml="8" mb="0">
                    <Text>{item.lineaDescripcion}</Text>
                  </Box>
                )}
                flexLeft={1}
                flexRight={8}
                rightColumnStyle={{ textAlign: 'left', paddingBottom: '0px' }}
              />
            )}
            rightContent={(
              <Box mt="12" ml="4" mb="0">
                <NumberFormat number={item.lineaPvp} />
              </Box>
            )}
            flexLeft={5}
            flexRight={1}
            rightColumnStyle={{ textAlign: 'right' }}
          />
        </Box>
      ))}
      </Box>
    </Box>

  );

  return content;
}
